import React, { useState } from 'react';

export default function LoginPage({ onLogin, loading, error }) {
  const [account, setAccount] = useState('');
  const [password, setPassword] = useState('');

  const submit = (e) => {
    e.preventDefault();
    if (account && password) onLogin(account, password);
  };

  return (
    <div style={{ minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center', background:'#f4f6f9' }}>
      <div style={{ background:'white', borderRadius:12, border:'0.5px solid #e0e0e0', padding:'36px 32px', width:360 }}>
        <div style={{ display:'flex', alignItems:'center', gap:10, marginBottom:28 }}>
          <div style={{ width:36, height:36, background:'#185FA5', borderRadius:8, display:'flex', alignItems:'center', justifyContent:'center' }}>
            <svg width="18" height="18" fill="white" viewBox="0 0 24 24"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 14.5v-9l6 4.5-6 4.5z"/></svg>
          </div>
          <div>
            <div style={{ fontSize:15, fontWeight:500 }}>MDVR System</div>
            <div style={{ fontSize:11, color:'#888' }}>Fleet Video Management</div>
          </div>
        </div>

        <form onSubmit={submit}>
          <div style={{ marginBottom:14 }}>
            <label style={{ fontSize:11, fontWeight:500, color:'#666', display:'block', marginBottom:4 }}>Username</label>
            <input
              type="text" value={account} onChange={e => setAccount(e.target.value)}
              placeholder="Enter username"
              style={{ width:'100%', padding:'8px 10px', fontSize:13, border:'0.5px solid #ccc', borderRadius:8, outline:'none' }}
            />
          </div>
          <div style={{ marginBottom:18 }}>
            <label style={{ fontSize:11, fontWeight:500, color:'#666', display:'block', marginBottom:4 }}>Password</label>
            <input
              type="password" value={password} onChange={e => setPassword(e.target.value)}
              placeholder="Enter password"
              style={{ width:'100%', padding:'8px 10px', fontSize:13, border:'0.5px solid #ccc', borderRadius:8, outline:'none' }}
            />
          </div>
          {error && <div style={{ fontSize:12, color:'#c0392b', background:'#fdecea', padding:'8px 10px', borderRadius:6, marginBottom:14 }}>{error}</div>}
          <button type="submit" disabled={loading}
            style={{ width:'100%', padding:'9px', background: loading ? '#aaa' : '#185FA5', color:'white', border:'none', borderRadius:8, fontSize:13, fontWeight:500, cursor: loading ? 'default' : 'pointer' }}>
            {loading ? 'Connecting...' : 'Sign in'}
          </button>
        </form>
        <div style={{ marginTop:16, fontSize:11, color:'#aaa', textAlign:'center' }}>
          Connected to CMSV6 · 103.6.245.78
        </div>
      </div>
    </div>
  );
}
